import React from "react";
import ClearPaused from "../common/ClearPause";
import { LogRenderContext } from "../LogRenderer";
import { getMediaDetails } from "../utils";

const MediaClearPaused = () => {
  const { log } = React.useContext(LogRenderContext);
  const { name, updatedBy, updatedAt } = getMediaDetails(log);
  return <ClearPaused name={name} updatedBy={updatedBy} updatedAt={updatedAt} />;
};

export default MediaClearPaused;
